"use client";

import { ReactNode } from "react";
import { AppProgressProvider } from "@bprogress/next";

export function ProgressProvider({ children }: { children: ReactNode }) {
  return (
    <AppProgressProvider color="#18C4F9" height="4px">
      {children}
    </AppProgressProvider>
  );
}
